module.exports = __webpack_public_path__ + "static/logo-13fb6c6a028e931f6d737b00dec10c7b.png";